import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
import _styled from "@emotion/styled-base";
export var Container = _styled("code", {
  target: "ef75ipa0"
})("position:relative;display:inline-block;background-color:#f3f3f3;color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grayDark;
}, ";font-family:Consolas,monaco,monospace;font-size:0.85em;letter-spacing:-0.3px;padding:3px 8px;border-radius:3px;");

if (typeof Container !== 'undefined' && Container && Container === Object(Container) && Object.isExtensible(Container) && !Container.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Container, '__filemeta', {
    configurable: true,
    value: {
      name: "Container",
      filename: "node_modules/@nejcm/docz-theme-extended/src/components/InlineCode/styles.js"
    }
  });
}